import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import s from './OrganizationSubjects.module.scss';
import ButtonPrimary from '../ButtonPrimary/ButtonPrimary';

const OrganizationSubjects = ({
  subjects = [],
  title,
  selectedSubjects = [],
  setSelectedSubjects,
}) => {
  const [isScrolledToEnd, setIsScrolledToEnd] = useState(false);
  const [isScrolledToStart, setIsScrolledToStart] = useState(true);
  const containerRef = useRef(null);

  const checkScroll = () => {
    const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
    setIsScrolledToStart(scrollLeft <= 0);
    setIsScrolledToEnd(scrollLeft + clientWidth >= scrollWidth - 1);
  };

  useEffect(() => {
    const container = containerRef.current;
    container.addEventListener('scroll', checkScroll);
    return () => container.removeEventListener('scroll', checkScroll);
  }, []);

  const toggleSelect = (subject) => {
    setSelectedSubjects((prev) =>
      prev.includes(subject.slug)
        ? prev.filter((s) => s !== subject.slug)
        : [...prev, subject.slug]
    );
  };

  const scrollDistance = 520;
  const scrollLeft = () =>
    containerRef.current.scrollTo({
      left: containerRef.current.scrollLeft - scrollDistance,
      behavior: 'smooth',
    });
  const scrollRight = () =>
    containerRef.current.scrollTo({
      left: containerRef.current.scrollLeft + scrollDistance,
      behavior: 'smooth',
    });

  return (
    <div className={s.Root}>
      <div className={s.Container}>
        {title && <h2 className={s.Title}>{title}</h2>}
        <div
          className={classNames(s.Fade, s.FadeLeft, {
            [s.Hidden]: isScrolledToStart,
          })}
        />
        <ul className={s.List} ref={containerRef}>
          {subjects.map((subject, index) => (
            <li key={index}>
              <ButtonPrimary
                size="xsmall"
                modifiers={[
                  'InlineFlex',
                  'NoWrap',
                  'EventCategory',
                  'Organization',
                ]}
                materialIcon={subject.icon}
                isActive={selectedSubjects.includes(subject.slug)}
                onClick={() => toggleSelect(subject)}
                aria-pressed={selectedSubjects.includes(subject.slug)}>
                <span
                  className={classNames(s.CategoryText, {
                    [s.NoIcon]: !subject.icon,
                  })}>
                  {subject.title}
                </span>
              </ButtonPrimary>
            </li>
          ))}
        </ul>
        <div
          className={classNames(s.Fade, {
            [s.Hidden]: isScrolledToEnd,
          })}
        />
      </div>
      <div className={s.ButtonsContainer}>
        <div
          className={classNames(s.Button, s.Prev, {
            [s.Disabled]: isScrolledToStart,
          })}>
          <ButtonPrimary
            onClick={scrollLeft}
            size="xsmall"
            modifiers={['InlineFlex', 'XsmallOnlyIcon']}
            icon="icon-chevron-left-white"
            aria-disabled={isScrolledToStart}
            tabIndex={isScrolledToStart ? -1 : undefined}
          />
        </div>
        <div
          className={classNames(s.Button, s.Next, {
            [s.Disabled]: isScrolledToEnd,
          })}>
          <ButtonPrimary
            onClick={scrollRight}
            size="xsmall"
            modifiers={['InlineFlex', 'XsmallOnlyIcon']}
            icon="icon-chevron-right-white"
            aria-disabled={isScrolledToEnd}
            tabIndex={isScrolledToEnd ? -1 : undefined}
          />
        </div>
      </div>
    </div>
  );
};

export default OrganizationSubjects;
